/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Button Styling
   ========================================================================== */
/*
Link text and underline.
$v: Link link and visited color.
$h: Link hover color.
$f: Link focus color.
$a: Link active color.
*/
.a-btn--link {
  padding: 1.5px 0;
  border-radius: 0;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-decoration-style: dotted;
  text-underline-offset: 4.5px;
}
.a-btn--link:has(svg) {
  gap: 0.3125rem;
}
.a-btn--link:has(svg)::before {
  display: none;
}

.a-btn--link, .a-btn--link:link, .a-btn--link:visited {
  text-decoration-color: var(--pacific);
  background-color: transparent;
  color: var(--pacific);
}
.a-btn--link:hover, .a-btn--link.hover {
  text-decoration-color: var(--pacific-dark);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--pacific-dark);
}
.a-btn--link:focus, .a-btn--link.focus {
  text-decoration-style: solid;
  background-color: transparent;
  outline: 1px dotted var(--pacific);
  color: var(--pacific);
}
.a-btn--link:active, .a-btn--link.active {
  text-decoration-color: var(--navy);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--navy);
}

.a-btn--link.a-btn--secondary, .a-btn--link.a-btn--secondary:link, .a-btn--link.a-btn--secondary:visited {
  text-decoration-color: var(--gray);
  background-color: transparent;
  color: var(--gray);
}
.a-btn--link.a-btn--secondary:hover, .a-btn--link.a-btn--secondary.hover {
  text-decoration-color: var(--gray-dark);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--gray-dark);
}
.a-btn--link.a-btn--secondary:focus, .a-btn--link.a-btn--secondary.focus {
  text-decoration-style: solid;
  background-color: transparent;
  outline: 1px dotted var(--gray);
  color: var(--gray);
}
.a-btn--link.a-btn--secondary:active, .a-btn--link.a-btn--secondary.active {
  text-decoration-color: var(--black);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--black);
}

.a-btn--link.a-btn--warning, .a-btn--link.a-btn--warning:link, .a-btn--link.a-btn--warning:visited {
  text-decoration-color: var(--red-mid-dark);
  background-color: transparent;
  color: var(--red-mid-dark);
}
.a-btn--link.a-btn--warning:hover, .a-btn--link.a-btn--warning.hover {
  text-decoration-color: var(--red-dark);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--red-dark);
}
.a-btn--link.a-btn--warning:focus, .a-btn--link.a-btn--warning.focus {
  text-decoration-style: solid;
  background-color: transparent;
  outline: 1px dotted var(--red-mid-dark);
  color: var(--red-mid-dark);
}
.a-btn--link.a-btn--warning:active, .a-btn--link.a-btn--warning.active {
  text-decoration-color: var(--gray-dark);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--gray-dark);
}